<template>
    <div class="aboutNav container-fluid" v-title data-title="多对多物联集团｜全周期AI健康管理服务平台">
      <ul class="container">
        <li>
          <router-link v-bind:to="{path:'/about/synopsis',query:{name:'why'}}">集团介绍</router-link>
        </li>
        <li>
          <router-link v-bind:to="{path:'/about/corporatehonors',query:{name:'why'}}">企业荣誉</router-link>
        </li>

        <!-- <li>
          <router-link v-bind:to="{path:'/about/foundingTeam',query:{name:'why'}}">组织架构</router-link>
        </li> -->
        <li>
          <router-link v-bind:to="{path:'/about/successCase',query:{name:'why'}}">案例分享</router-link>
        </li>
        <li>
          <router-link v-bind:to="{path:'/about/videoGroup',query:{name:'why'}}">视频荟萃</router-link>
        </li>
      </ul>
    </div>
</template>

<script>
  export default {
    name: "aboutNav"
  }
</script>

<style scoped lang="less">
  .aboutNav {
    background: #efefef;

    ul {
      display: flex;
      justify-content: left;
      font-size: 1.5rem;
      margin-bottom: 0;
      @media (max-width: 576px){
        padding: 0;
        margin: 0;
      }
      li {
        width: 20%;
        text-align: center;
        @media (max-width: 992px){
          font-size: 1.4rem;
        }
        @media (max-width: 768px){
          width: 24%;
          font-size: 1.3rem;
        }
        @media (max-width: 576px){
          width: 28%;
          font-size: 1.1rem;
        }

        a {
          padding: 8% 0;
          display: inline-block;
          width: 100%;
          height: 100%;
          color: #333!important;

          &.on {
            background: #ee7b1d;
            color: #fff!important;
          }
        }
        a:hover{
          color: #333!important;
          text-decoration: none!important;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/about/aboutNav.vue